export const windLevel = [
  1,
  [1, 5],
  [6, 11],
  [12, 19],
  [20, 28],
  [29, 38],
  [39, 49],
  [50, 61],
  [62, 74],
  [75, 88],
  [89, 102],
  [103, 117],
  [118, 134],
  [135, 149],
  [150, 166],
];

export const windSpeed = [
  {
    value: [348.76, 11.25],
    name: "北",
  },
  {
    value: [11.26, 33.25],
    name: "北东北",
  },
  {
    value: [33.26, 56.25],
    name: "东北",
  },
  {
    value: [56.26, 78.75],
    name: "东东北",
  },
  {
    value: [78.76, 101.25],
    name: "东",
  },
  {
    value: [101.26, 123.75],
    name: "东东南",
  },
  {
    value: [123.76, 146.25],
    name: "东南",
  },
  {
    value: [146.26, 168.75],
    name: "南东南",
  },
  {
    value: [168.76, 191.25],
    name: "南",
  },
  {
    value: [191.26, 213.75],
    name: "南西南",
  },
  {
    value: [213.76, 236.25],
    name: "西南",
  },
  {
    value: [236.26, 258.75],
    name: "西西南",
  },
  {
    value: [258.76, 281.25],
    name: "西",
  },
  {
    value: [281.76, 303.75],
    name: "西西北",
  },
  {
    value: [303.76, 326.25],
    name: "西北",
  },
  {
    value: [326.26, 348.75],
    name: "北西北",
  },
];

export const weatherDay = {
  CLEAR_DAY: "晴天",
  CLEAR_NIGHT: "晴夜",
  PARTLY_CLOUDY_DAY: "多云",
  PARTLY_CLOUDY_NIGHT: "多云",
  CLOUDY: "阴",
  RAIN: "雨",
  SNOW: "雪",
  WIND: "风",
  HAZE: "雾霾沙尘",
};

export const moonList = [
  "新月",
  "娥眉月",
  "上弦月",
  "盈凸月",
  "满月",
  "亏凸月",
  "下弦月",
  "残月",
];
export const moonRange = [
  [0, 0, true],
  [0, 0.25, false],
  [0.25, 0.25, true],
  [0.25, 0.5, false],
  [0.5, 0.5, true],
  [0.5, 0.75, false],
  [0.75, 0.75, true],
  [0.75, 1, false],
];

export const floodSeason = [
  "初八",
  "初九",
  "初十",
  "十一",
  "十二",
  "十三",
  "廿三",
  "廿四",
  "廿五",
  "廿六",
  "廿七",
];

export const fishingAreaForCaseData = [
  {
    color: "rgba(102,5,50,.8)",
    value: "阵风",
  },
  {
    color: "rgba(102,5,50,.8)",
    value: ">12",
  },
  {
    color: "rgba(128,5,50,.8)",
    value: "12",
  },
  {
    color: "rgba(179,5,54,.8)",
    value: "11",
  },
  {
    color: "rgba(230,0,0,.8)",
    value: "10",
  },
  {
    color: "rgba(255,43,0,.8)",
    value: "9",
  },
  {
    color: "rgba(255,85,0,.8)",
    value: "8",
  },
  {
    color: "rgba(255,170,0,.8)",
    value: "7",
  },
  {
    color: "rgba(242,202,0,.8)",
    value: "6",
  },
  {
    color: "rgba(218,242,0,.8)",
    value: "5",
  },
  {
    color: "rgba(13,255,94,.8)",
    value: "4",
  },
  {
    color: "rgba(13,237,251,.8)",
    value: "3",
  },
];

export const fishingAreaColorEnum = {
  3: "rgba(13,237,251,.8)",
  4: "rgba(13,255,94,.8)",
  5: "rgba(218,242,0,.8)",
  6: "rgba(242,202,0,.8)",
  7: "rgba(255,170,0,.8)",
  8: "rgba(255,85,0,.8)",
  9: "rgba(255,43,0,.8)",
  10: "rgba(230,0,0,.8)",
  11: "rgba(179,5,54,.8)",
  12: "rgba(128,5,50,.8)",
};

export const fishAreaLayerData = [
  {
    id: "fish",
    type: "fill",
    source: "fishSource",
    layout: {},
    paint: {
      "fill-color": ["get", "color"], //填充颜色
      "fill-opacity": 1,
      "fill-outline-color": "#FFF",
    },
  },
  {
    id: "fishCode",
    source: "fishCodeSource",
    type: "symbol",
    layout: {
      "text-field": ["get", "code"],
      "text-variable-anchor": ["center"],
      "text-radial-offset": 0,
      "text-justify": "auto",
      "text-allow-overlap": false, //碰撞属性 ture碰撞不消失，false碰撞消失
      "text-font": ["ztk"],
      "text-size": 12,
    },
    paint: {
      "text-color": "#fff", //文字颜色
    },
  },
  {
    id: "fishMore",
    type: "fill",
    source: "fishMoreSource",
    layout: {},
    paint: {
      "fill-opacity": 1,
      "fill-color": ["get", "color"],
      "fill-outline-color": "#FFF",
    },
  },
  {
    id: "fishCodeMore",
    source: "fishMoreCodeSource",
    type: "symbol",
    layout: {
      "text-field": ["get", "code"],
      "text-variable-anchor": ["center"],
      "text-radial-offset": 0,
      "text-justify": "auto",
      "text-allow-overlap": false,
      "text-font": ["ztk"],
      "text-size": 11,
    },
    paint: {
      "text-color": "#fff", //文字颜色
    },
  },
];

export const fishAreaSourceData = [
  "fishSource",
  "fishCodeSource",
  "fishMoreSource",
  "fishMoreCodeSource",
];
